import { memo as Memo, useMemo, useCallback, useEffect, useState, useRef } from 'react';
import { gsap, TimelineMax } from 'gsap';

//* HOC's
import widthUIContext from '@context/consumerHOC/UIConsumer';

//* Styles
import BusinessCardStyle from './style';

//* Components
import CustomLink from '@/components/global/CustomLink';
import Text from '@/components/global/Text';

const BusinessCard = Memo(({ businessCard, ...props }) => {
	//! Refs
	const contRef = useRef();
	const cardRef = useRef();
	const ref1 = useRef();
	const ref2 = useRef();
	const ref3 = useRef();
	const ref4 = useRef();
	const ref5 = useRef();

	//! States
	const [pause, setPause] = useState(false);

	//! Animation
	const tl1 = useMemo(() => new TimelineMax(), []);
	const tl2 = useMemo(() => new TimelineMax(), []);
	const tl3 = useMemo(() => new TimelineMax(), []);
	const tl4 = useMemo(() => new TimelineMax(), []);
	const tl5 = useMemo(() => new TimelineMax(), []);

	//! Component Did Mount
	useEffect(() => {
		props.screenSizes.screenS < window.innerWidth && animate();

		return () => {
			for (let i = 0; i < 5; i++) {
				eval(`tl${i + 1}`).kill();
			}
		};
	}, []);

	//! Animate Function
	const animate = useCallback(() => {
		const contObj = contRef?.current?.getBoundingClientRect();
		const cardObj = cardRef?.current?.getBoundingClientRect();

		const params = {
			leftMax: contObj.width - cardObj.width,
			topMax: contObj.height - cardObj.height,
		};

		const rand1 = gsap.utils.random(2, 5);
		const rand2 = gsap.utils.random(2, 5);

		for (let i = 1; i <= 5; i++) {
			const el = eval(`ref${i}`).current;

			eval(`tl${i}`).to(el, rand1, { x: params.leftMax, ease: 'none', delay: (5 - i) * 0.2 });
			eval(`tl${i}`).to(el, rand2, { y: params.topMax, ease: 'none', delay: (5 - i) * 0.2 }, 0);
			eval(`tl${i}`).to(el, rand1, { x: 0, ease: 'none', repeat: -1, yoyo: true }, rand1 + (5 - i) * 0.2);
			eval(`tl${i}`).to(el, rand2, { y: 0, ease: 'none', repeat: -1, yoyo: true }, rand2 + (5 - i) * 0.2);
		}
	}, [contRef, ref1, ref2, ref3, ref4, ref5]);

	//! On Mouse Enter
	const onMouseEnter = useCallback(() => {
		setPause(true);
	}, []);

	//! On Mouse Leave
	const onMouseLeave = useCallback(() => {
		setPause(false);
	}, []);

	//! Enable/Disable Animation
	useEffect(() => {
		if (pause) {
			for (let i = 0; i < 5; i++) {
				gsap.delayedCall((6 - i) * 0.2, () => {
					eval(`tl${i + 1}`).pause();
				});
			}
		} else {
			for (let i = 0; i < 5; i++) {
				gsap.delayedCall((6 - i) * 0.2, () => eval(`tl${i + 1}`).play());
			}
		}
	}, [pause]);

	//! Update Animation on Window Resize
	useEffect(() => {
		for (let i = 0; i < 5; i++) {
			eval(`tl${i + 1}`).clear();
		}

		props.screenSizes.screenS < window.innerWidth && animate();
	}, [props.winWidth]);

	return (
		<BusinessCardStyle
			ref={contRef}
			className={'businessCardCont'}>
			<div
				ref={cardRef}
				className={'businessCard'}>
				<span
					ref={ref1}
					className={'backBg'}
				/>
				<span
					ref={ref2}
					className={'backBg'}
				/>
				<span
					ref={ref3}
					className={'backBg'}
				/>
				<span
					ref={ref4}
					className={'backBg'}
				/>

				<div
					ref={ref5}
					className={'cardCont'}
					onMouseEnter={onMouseEnter}
					onMouseLeave={onMouseLeave}>
					<div className={'mailWrap'}>
						<CustomLink
							external
							ariaLabel={businessCard.mail}
							url={`mailto:${businessCard.mail}`}
							className={`font-poppins font-medium crCircle mail`}>
							{businessCard.mail}
						</CustomLink>
					</div>

					<div className={'numberAndLocationWrap'}>
						{businessCard.addresses.map((item, ind) => {
							return (
								<div
									key={ind}
									className={'numberAndLocationItem'}>
									<CustomLink
										external
										url={item.link}
										className='crCircle'
										ariaLabel={`${item.city} ${item.address} ${item.location}`}>
										<Text className={`b-city p-m font-poppins font-semi-bold`}>{item.city}</Text>

										<Text className={`p-m font-regular font-poppins`}>{item.address}</Text>

										<Text className={`p-m font-regular font-poppins`}>{item.location}</Text>
									</CustomLink>

									<CustomLink
										external
										ariaLabel={item.phone}
										url={`tel:${item.phone.replace(/\s+/g, '')}`}
										className={`p-m font-bold font-anonymous crCircle phone`}>
										{item.phone}
									</CustomLink>
								</div>
							);
						})}
					</div>
				</div>
			</div>
		</BusinessCardStyle>
	);
});

export default widthUIContext(BusinessCard, ['winWidth', 'screenSizes']);
